import { withTheme } from 'emotion-theming'
import PropTypes from 'prop-types'
import { withTranslation } from 'server/i18n'
import { Box } from 'reflexbox'
import BoatListingItem from 'components/BoatListingItem'
import ListingInfoBlock from 'components/ListingInfoBlock'
import getConfig from 'next/config'

import layoutTheme from 'theme/layout-theme'

const { publicRuntimeConfig } = getConfig()
const { CLOUDINARY_URL } = publicRuntimeConfig

const infoBlockPositions = {
    news: -1,
    help: 10,
    process: 34,
    dealer: 4
}

const BoatProvider = ({ t, boat, index, welcheYachtBox }) => {
    const { info, slug, attachments, price, id } = boat
    return (
        <>
            <Box theme={layoutTheme} width={[1, null, '48%', '32%']} mb={['40px']}>
                <BoatListingItem
                    id={id}
                    key={id}
                    images={(attachments || {}).images}
                    title={info.model}
                    type={info.type}
                    model={info.model}
                    condition={info.condition}
                    conditionCrm={info.conditionCrm ? info.conditionCrm : info.condition}
                    year={info.year}
                    length={info.length}
                    accommodation={info.accommodation}
                    price={price.displayValue}
                    vat={price.vat}
                    currency={price.currency}
                    link={slug}
                    brand={info.brand}
                />
            </Box>

            {/* News block */}
            {index === infoBlockPositions.news && (
                <Box theme={layoutTheme} width={[1, null, 1, '66%']} mb={['40px']}>
                    <ListingInfoBlock
                        image={`${CLOUDINARY_URL}/v1582626478/Static/sailing-into-the-sunset_nup13s.jpg`}
                        title="News Headline"
                        subtitle="Our main goal is to see your smile while stepping onboard of your yacht. Whether buying, managing or selling your yacht"
                        buttonText={t('read-more')}
                        buttonLink="/inquiry"
                        imageVerticalPosition="center"
                        isNewsBlock
                    />
                </Box>
            )}

            {index === infoBlockPositions.dealer && (
                <Box theme={layoutTheme} width={[1, null, '48%', '32%']} mb={['40px']}>
                    <ListingInfoBlock
                        title={t('merk-merk-exclusive-dealer')}
                        subtitle={t('we-will-guide-you-to-your-dream-yacht')}
                        dealer
                        buttonText={t('drop-your-anchor-now')}
                        buttonLink="/inquiry?type=buy"
                    />
                </Box>
            )}

            {/* {index === infoBlockPositions.help && (
                <Box theme={layoutTheme} width={[1, null, '48%', '32%']} mb={['40px']}>
                    <ListingInfoBlock
                        title={t('choose-merk-merk')}
                        subtitle={t('why-good-question')}
                        buttonText={t('find-out-why')}
                        buttonLink="/inquiry?type=buy"
                    />
                </Box>
            )} */}

            {index === infoBlockPositions.process && (
                <Box theme={layoutTheme} width={[1, null, 1, '66%']} mb={['40px']}>
                    <ListingInfoBlock
                        image={`${CLOUDINARY_URL}/v1582626478/Static/sales-team_fhyihx.jpg`}
                        title={welcheYachtBox.title}
                        subtitle={welcheYachtBox.text}
                        buttonText={t('read-more')}
                        buttonLink="/about"
                        imageVerticalPosition="top"
                    />
                </Box>
            )}
        </>
    )
}

BoatProvider.propTypes = {
    t: PropTypes.func.isRequired,
    boat: PropTypes.oneOfType([() => null, PropTypes.object]).isRequired,
    index: PropTypes.number.isRequired,
    welcheYachtBox: PropTypes.shape({
        title: PropTypes.string,
        text: PropTypes.string,
        image: PropTypes.object
    })
}

BoatProvider.defaultProps = {
    welcheYachtBox: {}
}

export default withTranslation('common')(withTheme(BoatProvider))
